function createMarkup(text: string) {
	return {__html: text};
}

export {
	createMarkup
};